export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleString();
};

export const formatAmount = (amount: number) => {
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD'
  }).format(amount);
};

export const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case 'approved':
      return 'bg-green-500';
    case 'declined':
      return 'bg-red-500';
    case 'returned':
      return 'bg-yellow-500';
    default:
      return 'bg-gray-500';
  }
};

export const formatPercentage = (value: number) => {
  return `${(value * 100).toFixed(1)}%`;
};